class Config {
  static envName = process.env.NODE_ENV;
  static apiUrl = () => {
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL;
    } else if (process.env.NODE_ENV === "production") {
      return "https://x4wq1u6rne.execute-api.us-west-2.amazonaws.com/Prod";
    } else {
      return "http://localhost:5000";
    }
  };
  static allowedEmailDomains = ["uncommon.is", "teamdriveaway.com"];
}

export default Config;



// WEBPACK FOOTER //
// ./src/lib/config.js